<template>
  <div id="webcams">
    <div class="container">
      <h1>Webcams</h1>
      <form @submit.prevent>
        <div class="form-group">
          <div
            class="row mb-1"
            v-for="(cam, index) in cams"
          >
            <div class="col">
              <input
                v-model="cam.title"
                type="text"
                class="form-control"
                placeholder="Cam Title"
              >
            </div><!-- /.col -->
            <div class="col">
              <input
                v-model="cam.url"
                type="text"
                class="form-control"
                placeholder="Cam URL"
              >
            </div><!-- /.col -->
            <div class="col-1">
              <b-btn
                class="btn-danger"
                @click="removeCam(index)"
              >
                <i class="fas fa-minus"></i>
              </b-btn>
            </div><!-- /.col-1 -->
          </div><!-- /.row -->
        </div><!-- /.form-group -->
        <b-btn
          @click="addCam()"
        >Add Webcam</b-btn>
      </form>
      <button
        class="btn btn-primary mb-4 mt-4"
        @click="saveSettings()"
      >
        Save Settings
      </button>
    </div><!-- /.container -->
  </div><!-- /#trailHub -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../../../firebaseConfig.js')

export default {
  data() {
    return {
      cams: []
    }
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  created() {
    if (this.dashboard.data.modules.webcams.cams) {
      this.cams = this.dashboard.data.modules.webcams.cams
    }
  },
  methods: {
    saveSettings() {
      this.dashboard.data.modules.webcams.cams = this.cams
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        alert('Successfully updated settings!')
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      }).catch(err => {
        console.log(err.message)
      })
    },
    removeCam(index) {
      this.cams.splice(index, 1)
    },
    addCam() {
      this.cams.push({
        title: '',
        url: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/modules/Webcams.vue